import type { IosConstructionWebViewWindow, AndroidConstructionWebViewWindow } from '@/types/webViewBridge'
import * as loggers from '@/utils/loggers'

const isIosConstructionWebView = (w: Window): w is IosConstructionWebViewWindow => {
  return 'webkit' in w
    && (w as IosConstructionWebViewWindow).webkit?.messageHandlers?.constructionCreated != null
}

const isAndroidConstructionWebView = (w: Window): w is AndroidConstructionWebViewWindow => {
  return 'android' in w
    && typeof (w as AndroidConstructionWebViewWindow).android?.constructionCreated === 'function'
}

/**
 * 工事作成完了をネイティブに通知する
 */
export const sendConstructionCreated = (constructionId: string) => {
  const json = JSON.stringify({ cloud_construction_id: constructionId })
  if (isIosConstructionWebView(window)) {
    window.webkit.messageHandlers.constructionCreated.postMessage(json)
    return
  }
  if (isAndroidConstructionWebView(window)) {
    window.android.constructionCreated(json)
    return
  }
  console.info('[webViewBridge] constructionCreated (no native handler)', constructionId)
}

/**
 * WebViewを閉じるイベントをネイティブに通知する
 * @param errorReason 正常系（ユーザー操作による閉じる）以外で呼ぶ場合の理由。
 *                    指定するとconsoleとDatadogにログを出力する
 * @param context ログに付与する追加情報
 */
export const sendConstructionCreateClosed = (errorReason?: string, context?: object) => {
  if (errorReason) {
    const message = `[webViewBridge] constructionCreateClosed (error): ${errorReason}`
    console.warn(message, context)
    loggers.warn(message, { ...context, online: navigator.onLine })
  }
  if (isIosConstructionWebView(window)) {
    window.webkit.messageHandlers.constructionCreateClosed.postMessage(null)
    return
  }
  if (isAndroidConstructionWebView(window)) {
    window.android.constructionCreateClosed()
    return
  }
  console.info('[webViewBridge] constructionCreateClosed (no native handler)')
}
